<template>
	
</template>
<script>
export default {
  beforeRouteEnter(to, from, next) {

    console.log(from)
    next(vm => {
      vm.$router.replace({path:from.path , query: { activeName:from.query.activeName }})
      // 跳到该路由页面后，再替换为from.path来源路径
    })
  }
}

</script>
<style></style>


// WEBPACK FOOTER //
// src/components/common/refresh.vue